import React from 'react';
import DashboardController from '../pages/dashboard/DashboardController';
import LeavesController from '../pages/myProfile/Leaves/LeavesController';
import LoansController from '../pages/myProfile/Loans/LoansController';
import PersonalDetailsController from '../pages/myProfile/PersonalDetails/PersonalDetailsController';
import SalaryController from '../pages/myProfile/Salary/SalaryController';
import DocumentsController from '../pages/myProfile/Documents/DocumentsController';
import AttendanceController from '../pages/myProfile/Attendance/AttendanceController';
import ClaimsController from '../pages/myProfile/Claims/ClaimsController';
import AssetsController from '../pages/myProfile/Assets/AssetsController';
import InsuranceController from '../pages/myProfile/Insurance/InsuranceController';
import EmpDirectoryController from '../pages/employeeDirectory/EmpDirectoryController';
import OffBoardingController from '../pages/myProfile/OffBoarding/OffBoardingController';
import DependentsController from '../pages/myProfile/Dependents/DependentsController';
import AnnouncementController from '../pages/Announcement/AnnouncementController';
import SSOController from '../pages/SSO/SSOController';
import NotificationController from '../pages/Notifications/NotificationController';
import ResetPasswordController from '../pages/ResetPassword/ResetPasswordController';
import ShiftAndScheduleController from '../pages/myProfile/ShiftAndSchedule/ShiftAndScheduleController';
import TrainingController from '../pages/myProfile/Training/TrainingController';
import LetterGenerationController from '../pages/letterGeneration/LetterGenerationController';
import ActionRequiredController from '../pages/ActionRequired/ActionRequiredController';
import PerfomanceController from '../pages/Perfomance/PerfomanceController';
import ToDoTaskController from '../pages/toDoTasks/ToDoTaskController';
import UnderMaintenance from '../pages/500/UnderMaintenance';
import ShiftAndScheduleController2UI from '../pages/myProfile/ShiftAndSchedule/ui-v2/ShiftAndScheduleController';
import ShiftAndScheduleControllerSwapShift2UI from '../pages/myProfile/ShiftAndSchedule/ui-v2-swap-shift/ShiftAndScheduleController';
import SuggestionController from '../pages/Suggestion/SuggestionController';
import WarningComplaintController from '../pages/myProfile/WarningAndComplaint/WarningComplaintController';
import AttendanceexceptionController from '../pages/AttendanceException/AttendanceexceptionController';
import DigitalSignatureController from '../pages/myProfile/DigitalSignature/DigitalSignatureController';
import ComplaintsController from '../pages/myProfile/Complaints/ComplaintsController';

const indexRoutes = [
  { path: '/dashboard', name: 'Dashboard', component: <DashboardController /> },
  // { path: "/", name: "/", component: <AuthController /> },
  {
    path: '/500',
    name: '500',
    component: <UnderMaintenance />,
  },
  {
    path: '/employeePersonalDetails',
    name: 'PersonalDetailsController',
    component: <PersonalDetailsController />,
  },
  {
    path: '/employeedirectory',
    name: 'EmployeeDirectory',
    component: <EmpDirectoryController />,
  },
  {
    path: '/employeeannouncement',
    name: 'EmployeeAnnouncement',
    component: <AnnouncementController />,
  },
  {
    path: '/actionRequired',
    name: 'ActionRequired',
    component: <ActionRequiredController />,
  },
  {
    path: '/empLetterGeneration',
    name: 'EmpLetterGeneration',
    component: <LetterGenerationController />,
  },
  {
    path: '/employeeLetterGeneration',
    name: 'EmpLetterGeneration',
    component: <LetterGenerationController />,
  },
  {
    path: '/empNotification',
    name: 'EmployeeNotification',
    component: <NotificationController />,
  },
  {
    path: '/employeeSalary',
    name: 'EmployeeSalary',
    component: <SalaryController />,
  },
  {
    path: '/employeeDocuments',
    name: 'EmployeeDocuments',
    component: <DocumentsController />,
  },
  {
    path: '/employeeAttendance',
    name: 'EmployeeAttendance',
    component: <AttendanceController />,
  },
  {
    path: '/employeeShiftAndSchedule',
    name: 'EmployeeShiftAndSchedule',
    component: <ShiftAndScheduleController2UI />,
  },
  {
    path: '/employeeShiftAndSchedule/swap-shift',
    name: 'EmployeeShiftAndScheduleSwapShift',
    component: <ShiftAndScheduleControllerSwapShift2UI />,
  },
  {
    path: '/employeeLeaves',
    name: 'EmployeeLeaves',
    component: <LeavesController />,
  },
  {
    path: '/employeeRecurringPayments',
    name: 'RecurringPayment',
    component: <LoansController />,
  },
  {
    path: '/employeeClaims',
    name: 'EmployeeClaims',
    component: <ClaimsController />,
  },
  {
    path: '/employeeAssets',
    name: 'EmployeeAssets',
    component: <AssetsController />,
  },
  {
    path: '/employeeInsurance',
    name: 'EmployeeInsurance',
    component: <InsuranceController />,
  },
    {
    path: '/employeeComplaints',
    name: 'EmployeeComplaints',
    component: <ComplaintsController />,
  },
  {
    path: '/employeeTraining',
    name: 'EmployeeTraining',
    component: <TrainingController />,
  },
  {
    path: '/employeeOffBoarding',
    name: 'EmployeeOffBoarding',
    component: <OffBoardingController />,
  },
  {
    path: '/employeeDependents',
    name: 'EmployeeDependents',
    component: <DependentsController />,
  },
  {
    path: '/gotoEmployee',
    name: 'GotoEmployee',
    component: <SSOController />,
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: <ResetPasswordController />,
  },
  {
    path: '/perfomance',
    name: 'perfomance',
    component: <PerfomanceController />,
  },
  {
    path: '/toDoTask',
    name: 'ToDoTask',
    component: <ToDoTaskController />,
  },
  {
    path: '/suggestion',
    name: 'Suggestion',
    component: <SuggestionController />,
  },
  {
    path: '/WarningComplaint',
    name: 'Warning & Complaint',
    component: <WarningComplaintController />,
  },
  {
    path: '/attendanceException',
    name: 'Attendance Exception',
    component: <AttendanceexceptionController />,
  },
  {
    path: '/digitalSignatureDocs',
    name: 'Digital Signature Docs',
    component: <DigitalSignatureController />,
  },
];

export default indexRoutes;
